import { useState, type FC } from 'react';
import { Snackbar, Alert, AlertTitle, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ToastProps {
	onClose?: () => void;
	body: string;
	title?: string;
	severity: 'error' | 'warning' | 'info' | 'success';
	autoHideDuration?: number;
}

const Toast: FC<ToastProps> = ({ onClose, body, title, severity, autoHideDuration = 5000 }) => {
	const [open, setOpen] = useState(true);

	const handleClose = () => {
		if (onClose) {
			onClose();
		}
		setOpen(false);
	};

	return (
		<Snackbar
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			open={open}
			onClose={handleClose}
			autoHideDuration={autoHideDuration}
		>
			<Alert
				severity={severity}
				action={
					<IconButton aria-label="close" color="inherit" size="small" onClick={handleClose}>
						<CloseIcon fontSize="small" />
					</IconButton>
				}
			>
				{title && <AlertTitle sx={{ typography: 'h6' }}>{title}</AlertTitle>}
				<Typography>{body}</Typography>
			</Alert>
		</Snackbar>
	);
};

export default Toast;
